// src/data/testimonials.ts
export interface Testimonial {
  id: string;
  name: string;
  location: string;
  text: string;
  rating: number;
  date: string;
  profession?: string;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Janice Emefa',
    location: 'East Legon, Accra',
    text: 'AJ transformed my wedding nails with beautiful Adinkra symbols. The quality lasted through all the ceremonies in Kumasi.',
    rating: 5,
    date: '2024-01-15',
    profession: 'Marketing Executive'
  },
  {
    id: '2',
    name: 'Farida',
    location: 'Cantonments, Accra',
    text: 'As a lawyer, I need professional nails that withstand Accra\'s humidity. AJ\'s gel overlays are the only ones that last.',
    rating: 5,
    date: '2024-02-20',
    profession: 'Corporate Lawyer'
  },
  {
    id: '3',
    name: 'Davida Addo',
    location: 'Valley View, Accra',
    text: 'The African Spa Pedicure with neem leaves is revolutionary! My feet have never felt better after long market days.',
    rating: 5,
    date: '2022-03-05',
    profession: 'Fashion Designer'
  },
  {
    id: '4',
    name: 'Kelvin',
    location: 'Airport Residential',
    text: 'Professional service for corporate events. AJ handled our company\'s wellness day for 15 employees seamlessly.',
    rating: 5,
    date: '2023-03-18',
    profession: 'HR Manager'
  },
  {
    id: '5',
    name: 'Obroni',
    location: 'Bogoso, Takoradi',
    text: 'The attention to hygiene and detail is exceptional. I trust AJ with my nails completely.',
    rating: 5,
    date: '2025-11-02',
    profession: 'Nurse'
  },
  {
    id: '6',
    name: 'Kojo Designer',
    location: 'Osu, Accra',
    text: 'Brought my sister for anniversary nails, exceptional service and beautiful Kente-inspired designs.',
    rating: 5,
    date: '2024-04-10',
    profession: 'Graphic Designer'
  }
];